export const CLIP_PATH_SIZE_MD = 10;
export const CLIP_PATH_SIZE_LG = 32;
